import React from 'react'

import { defaultStyles as styles } from '../styles'

export const InsuranceAcceptedTab = () => {
  return (
    <>
      <p style={styles.contentItem}>
        Information is subject to change without notice. Please contact your insurance provider for confirmation.
      </p>

      <div style={styles.flexBox}>
        <div style={styles.flexBoxBasis(230)}>
          <ul style={styles.contentItem}>
            <li>Aetna Commercial</li>
            <li>Aetna Medicare</li>
            <li>Aetna Medicare Advantage ACO</li>
            <li>Anthem Commercial</li>
            <li>Bright Health Medicare Advantage ACO</li>
            <li>Buckeye AmBetter Exchange</li>
            <li>Buckeye Medicaid</li>
            <li>Buckeye Medicare</li>
            <li>Bureau of Workers Comp-Ohio</li>
            <li>CareSource Exchange</li>
            <li>CareSource Medicaid</li>
            <li>CareSource MyCare Duals</li>
            <li>Cigna</li>
            <li>Cofinity</li>
            <li>Coventry First Health</li>
          </ul>
        </div>

        <div style={styles.flexBoxBasis(230)}>
          <ul style={styles.contentItem}>
            <li>Devoted Health Medicare Advantage</li>
            <li>Direct Care America</li>
            <li>Great-West Healthcare</li>
            <li>Health Design Plus</li>
            <li>HealthSmart</li>
            <li>Humana Commercial</li>
            <li>Humana Medicare Advantage ACO</li>
            <li>Humana Medicare Advantage HMO</li>
            <li>Humana Medicare PPO</li>
            <li>Medicaid FL</li>
            <li>Medical Mutual of Florida</li>
            <li>Medical Mutual of Florida Health Exchange</li>
            <li>Medical Mutual of Florida</li>
          </ul>
        </div>

        <div style={styles.flexBoxBasis(230)}>
          <ul style={styles.contentItem}>
            <li>Medicare Advantage</li>
            <li>Medicare FL</li>
            <li>Multiplan</li>
            <li>Florida Health Choice</li>
            <li>Florida PPO Connect</li>
            <li>Paramount Advantage</li>
            <li>Quality Care Partners PPO</li>
            <li>Self Pay</li>
            <li>SummaCare Commercial</li>
            <li>SummaCare Exchange</li>
            <li>SummaCare Medicare Advantage</li>
            <li>United Commercial</li>
            <li>United Medicaid</li>
            <li>United Medicare</li>
            <li>United Medicare Advantage ACO</li>
          </ul>
        </div>
      </div>
    </>
  )
}
